import "../scss/page.scss";

import "../scss/beup.scss";

import "./scripts/beup/base.js";
import "./scripts/global/faq.js";